module.exports = __webpack_public_path__ + "static/media/sugata_chanda.76dedb1a.pdf";